import styled from 'styled-components'
import { darkBlue, linkNavyBlue } from '../../../styles/settings/colors'
import { title24Galano, txt14OpenSans } from '../../../styles/settings/types'

import content from '../../../styles/_objects/content'
import rem from '../../../styles/tools/rem'
import media from '../../../styles/tools/media'

export const Header = styled.nav`
  align-items: center;
  display: flex;
  justify-content: space-between;

  border-bottom: 1px solid #e9e9ef;

  ${media.small`
        padding: ${rem('20px')} ${rem('30px')};
        position: relative;
        text-align: center;
        a {
            margin: 0 auto;
        }
    `};
`

export const HeaderContent = styled.div`
  ${content};
  height: 96px;
  padding: ${rem('40px')} ${rem('65px')} ${rem('5px')};
`

export const Hr = styled.hr`
  width: 100%;
  height: 1px;
  background-color: #e9e9ef;
`

export const Heading = styled.h1`
  ${title24Galano} color: ${darkBlue};
  font-size: ${rem('40px')};
  margin-bottom: 0;

  ${media.small`
        font-size: ${rem('24px')};
        margin: 0;
    `};
`

export const Paragraph = styled.p`
  ${txt14OpenSans} color: ${darkBlue};
  max-width: ${rem('430px')};
  margin-top: 0;
`

export const Wrapper = styled.div`
  margin-top: ${rem('32px')};
`

export const Content = styled.section`
  ${content};
  margin: ${rem('42px')} auto;

  ${media.small`
        margin: ${rem('10px')} auto ${rem('42px')};
    `};
`

export const Logo = `
    height: ${rem('30px')};
    fill: ${linkNavyBlue};
    width: ${rem('74px')};
`



// WEBPACK FOOTER //
// ./src/app/pages/FirstAccessCreatePassword/styles.js